import { Project, SimpleProject } from '../../models/models';
import { Action, ActionWithPayload, createAction, withMatcher } from '../../utils/reducer/reducer.utils';
import { PROJECT_ACTION_TYPES } from './project.type';

export type GetProjectStart = ActionWithPayload<
    PROJECT_ACTION_TYPES.GET_PROJECT_START,
    { projectId: number; nodeId: number | null; }
>;

export type GetProjectSuccess = ActionWithPayload<
    PROJECT_ACTION_TYPES.GET_PROJECT_SUCCESS,
    { projectSelected: Project; nodeId: number | null; }
>;

export type GetProjectFailed = ActionWithPayload<
    PROJECT_ACTION_TYPES.GET_PROJECT_FAILED,
    string
>;

export type GetMyProjectsStart = Action<PROJECT_ACTION_TYPES.GET_MY_PROJECTS_START>;

export type GetMyProjectsSuccess = ActionWithPayload<
    PROJECT_ACTION_TYPES.GET_MY_PROJECTS_SUCCESS,
    { myProjects: SimpleProject[]; }
>;

export type GetMyProjectsFailed = ActionWithPayload<PROJECT_ACTION_TYPES.GET_MY_PROJECTS_FAILED, string>;

export type ClearProjectSelected = Action<
    PROJECT_ACTION_TYPES.CLEAR_PROJECT_SELECTED
>;

export type ClearNodeProjectSelected = Action<
    PROJECT_ACTION_TYPES.CLEAR_NODE_PROJECT_SELECTED
>;

export const getProjectStart = withMatcher(
    (projectId: number, nodeId: number | null): GetProjectStart =>
        createAction(PROJECT_ACTION_TYPES.GET_PROJECT_START, { projectId, nodeId })
);

export const getProjectSuccess = withMatcher(
    (projectSelected: Project, nodeId: number | null): GetProjectSuccess =>
        createAction(PROJECT_ACTION_TYPES.GET_PROJECT_SUCCESS, { projectSelected, nodeId })
);

export const getProjectFailed = withMatcher(
    (error: string): GetProjectFailed =>
        createAction(PROJECT_ACTION_TYPES.GET_PROJECT_FAILED, error)
);

export const getMyProjectsStart = withMatcher(
    (): GetMyProjectsStart =>
        createAction(PROJECT_ACTION_TYPES.GET_MY_PROJECTS_START)
);

export const getMyProjectsSuccess = withMatcher(
    (myProjects: SimpleProject[]): GetMyProjectsSuccess =>
        createAction(PROJECT_ACTION_TYPES.GET_MY_PROJECTS_SUCCESS, { myProjects })
);

export const getMyProjectsFailed = withMatcher(
    (error: string): GetMyProjectsFailed =>
        createAction(PROJECT_ACTION_TYPES.GET_MY_PROJECTS_FAILED, error)
);

export const clearProjectSelected = withMatcher(
    (): ClearProjectSelected =>
        createAction(PROJECT_ACTION_TYPES.CLEAR_PROJECT_SELECTED)
);

export const clearNodeProjectSelected = withMatcher(
    (): ClearNodeProjectSelected =>
        createAction(PROJECT_ACTION_TYPES.CLEAR_NODE_PROJECT_SELECTED)
);